import defaultSchema from '@/data/schemas/de/default.json'
import miniSchema from '@/data/schemas/de/mini.json'

export type Schema = {
  [string: string]: Array<object>
}

export const schemas: Schema = {
  'de-DE': [defaultSchema, miniSchema]
}
